import React from 'react';

const accent = "#a259f7";

// Универсальный компонент дерева категорий и уровней
function TreeDirectory({ nodes, openNodes, setOpenNodes, loadChildren, onSelectNode, selectedNodeId, level = 0 }) {
  return (
    <div>
      {(nodes || []).flatMap((node) => {
        // Если это level group (отображаем плашку уровня)
        if (node.isLevelGroup) {
          // Пропускаем "Уровень 0" как отдельную группу, рендерим только её скиллы
          if (node.title === 'Уровень 0' || node.level === 0) {
            return node.skills ? node.skills.map(child => (
              <TreeDirectory
                key={child.id}
                nodes={[child]}
                openNodes={openNodes}
                setOpenNodes={setOpenNodes}
                loadChildren={loadChildren}
                onSelectNode={onSelectNode}
                selectedNodeId={selectedNodeId}
                level={level}
              />
            )) : null;
          }
          const isOpen = openNodes[`level-${node.level}-${node.parentId}`] ?? false;
          const isSelected = selectedNodeId === `level-${node.level}-${node.parentId}`;
          return (
            <div key={`level-${node.level}-${node.parentId}`}>
              <div
                onClick={() => {
                  setOpenNodes((prev) => ({ ...prev, [`level-${node.level}-${node.parentId}`]: !isOpen }));
                  onSelectNode({ ...node, id: `level-${node.level}-${node.parentId}` });
                }}
                style={{
                  cursor: 'pointer',
                  padding: `8px 12px 8px ${16 + level * 20}px`,
                  background: isSelected ? accent : '#f7f3ff',
                  color: isSelected ? '#fff' : '#2d0036',
                  fontWeight: isSelected ? 700 : 400,
                  borderRadius: 10,
                  marginBottom: 4,
                  marginTop: 6,
                  userSelect: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  transition: 'background 0.2s',
                  boxShadow: isSelected ? '0 2px 8px #a259f733' : undefined,
                }}
              >
                <span style={{ marginRight: 8, fontSize: 16, transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)', transition: 'transform 0.2s', color: isSelected ? '#fff' : '#a259f7' }}>▶</span>
                {`Уровень ${node.level}`}
              </div>
              {isOpen && (
                <div style={{ marginLeft: 20 }}>
                  <TreeDirectory
                    nodes={node.skills}
                    openNodes={openNodes}
                    setOpenNodes={setOpenNodes}
                    loadChildren={loadChildren}
                    onSelectNode={onSelectNode}
                    selectedNodeId={selectedNodeId}
                    level={level + 1}
                  />
                </div>
              )}
            </div>
          );
        }
        // Обычный skill
        const isOpen = openNodes[node.id] ?? false;
        const isSelected = selectedNodeId === node.id;
        return (
          <div key={node.id}>
            <div
              onClick={() => {
                onSelectNode(node);
                if (node.hasChildren && !node.childrenLoaded) {
                  loadChildren(node);
                }
                if (node.hasChildren) {
                  setOpenNodes((prev) => ({ ...prev, [node.id]: !isOpen }));
                }
              }}
              style={{
                cursor: node.hasChildren ? 'pointer' : 'default',
                padding: `8px 4px 8px ${4 + (level + (node.parentLevel ? 1 : 0)) * 4}px`,
                background: isSelected ? accent : '#f7f3ff',
                color: isSelected ? '#fff' : '#2d0036',
                fontWeight: isSelected ? 700 : 400,
                borderRadius: 10,
                marginBottom: 4,
                userSelect: 'none',
                display: 'flex',
                alignItems: 'center',
                transition: 'background 0.2s',
                boxShadow: isSelected ? '0 2px 8px #a259f733' : undefined,
              }}
            >
              {node.hasChildren && (
                <span
                  style={{
                    display: 'inline-block',
                    marginRight: 8,
                    fontSize: 16,
                    transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)',
                    transition: 'transform 0.2s',
                    color: isSelected ? '#fff' : '#a259f7',
                  }}
                >
                  ▶
                </span>
              )}
              <span className="skill-title">{node.title || node.description || `ID ${node.id || ''}`}</span>
            </div>
            {node.hasChildren && isOpen && Array.isArray(node.children) && (
              <div style={{ marginLeft: 20 }}>
                <TreeDirectory
                  nodes={node.children}
                  openNodes={openNodes}
                  setOpenNodes={setOpenNodes}
                  loadChildren={loadChildren}
                  onSelectNode={onSelectNode}
                  selectedNodeId={selectedNodeId}
                  level={level + 1}
                />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default TreeDirectory; 